import ProtectedRoute from './view';

export default ProtectedRoute;
